// extracted by mini-css-extract-plugin
export default {"titleInputWrapper":"IssueTitleInput-module__titleInputWrapper__VoqhIZ_"};